module.exports = __webpack_public_path__ + "static/media/sports_12.e3ca2dfc.jpg";